module.exports = __webpack_public_path__ + "static/media/Group1585.06910070.svg";